
import {
    ANALYZE_2_OPSUB_ACTION_TYPE,
} from '../../sagas/analyze2opsub';

import {
    GET_PROJECT_ACTION_TYPE
} from '../../sagas/project';

import { createLoaderReducer } from '../../common/client/reducers/loader';

const initialState = {
    // nop;
};

export function getAnalyzeData(state) {
    return state.data?.result?.result;
}

export function isLoading(state) {
    return state.loading;
}

export default function createReducer() {
    const loaderReducer = createLoaderReducer(ANALYZE_2_OPSUB_ACTION_TYPE);

    return (state = initialState, action) => {
        switch (action.type) {
            case GET_PROJECT_ACTION_TYPE.SUCCESS:
                return {
                    ...initialState
                };
            default:
                return loaderReducer(state, action);
        }
    };
}
